import { UseFormReturn } from "react-hook-form";
import FormSection from "../form-fields/FormSection";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { VisaPathway } from "../VisaPathwaySelection";

interface ExperienceProps {
  form: UseFormReturn<any>;
  visaPathway: VisaPathway;
}

const Experience = ({ form }: ExperienceProps) => {
  return (
    <FormSection
      title="Additional Professional Criteria"
      description="Tell us more about your professional experience."
    >
      <div className="space-y-8">
        <FormField
          control={form.control}
          name="experience.nonQualifyingProfession"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Is your profession on the list of non-qualifying professions? *</FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="no" />
                    </FormControl>
                    <FormLabel className="font-normal">No</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="not_sure" />
                    </FormControl>
                    <FormLabel className="font-normal">I am not sure</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="yes" />
                    </FormControl>
                    <FormLabel className="font-normal">Yes</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="experience.technologyExperience"
          render={({ field }) => (
            <FormItem>
              <FormLabel>How many years of Tech-related experience do you have? *</FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="less_than_5" />
                    </FormControl>
                    <FormLabel className="font-normal">Less than 5 years</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="more_than_5" />
                    </FormControl>
                    <FormLabel className="font-normal">More than 5 years</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="none" />
                    </FormControl>
                    <FormLabel className="font-normal">None</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </FormSection>
  );
};

export default Experience;